import { createClient } from '@supabase/supabase-js';
import config from '../config/env';

// Create Supabase client with configuration
export const supabase = createClient(
  config?.supabase?.url,
  config?.supabase?.anonKey,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
    db: {
      schema: 'public',
    },
    global: {
      headers: {
        'x-app-name': config?.appTag,
      },
    },
  }
);

export default supabase;